import { render, staticRenderFns } from "./ConfirmPassport.vue?vue&type=template&id=1ba27178&scoped=true&"
import script from "./ConfirmPassport.vue?vue&type=script&lang=js&"
export * from "./ConfirmPassport.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPassport.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConfirmPassport.vue?vue&type=style&index=1&id=1ba27178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba27178",
  null
  
)

export default component.exports